import { useTypeSelectors } from "hooks/useTypeSelectors";
import { useLocation } from "react-router-dom";
import { Box, Button, Drawer, IconButton, Typography } from "@material-ui/core";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import { FC, ReactNode, useState } from "react";
import { AppBarComponent } from "componentsNew/appMenus/AppBar";

import { CollapseSubMenu } from "./CollapseSubMenu";
import { useDrawerMenuStyles } from "./styles";
import useNavMenu from "hooks/useNavMenu";
import useResize from "hooks/useResize";
import { useDispatch } from "react-redux";
import { toggleNavMenu } from "actions/navMenuActions";
import { MobileBurgerButton } from "./MobileBurgerButton";
import { LogoPng } from "icon/LogoPng";

interface DrawerMenuProps {
  children: ReactNode;
}

export const DrawerMenu: FC<DrawerMenuProps> = ({ children }) => {
  const classes = useDrawerMenuStyles();
  const params = useLocation();
  const { width } = useResize();
  const dispatch = useDispatch();
  const { userData } = useTypeSelectors((state) => state.auth);
  const { isOpen } = useTypeSelectors((state) => state.navMenuState);
  const { activeNavLinkList } = useTypeSelectors((state) => state.settings);
  const [drawerWidth, setDrawerWidth] = useState(1);
  const isMenuOpen = drawerWidth === 1;

  const handleChangeDrawerWidth = () => {
    isMenuOpen ? setDrawerWidth(0) : setDrawerWidth(1);
  };

  const listMenu = useNavMenu();

  return (
    <>
      <AppBarComponent />
      <Box className={classes.body}>
        <Drawer
          className={`${classes.drawerContainer} ${drawerWidth ? classes.customMaxWidth : classes.customMinWidth} ${!isOpen && width < 1280 ? classes.disableMinWidth : ""}`}
          variant={ width > 1280 ? "persistent" : "temporary"}
          anchor="left"
          open={ width < 1280 ? isOpen : true}
          onClose={() => dispatch(toggleNavMenu())}
        >
          <Box
            className={`${classes.drawerBox} ${drawerWidth ? classes.customMaxWidth : classes.customMinWidth} ${!isOpen && width < 1280 ? classes.disableMinWidth : ""}`}
          >
            <Box className={classes.drawer}>
              <Box className={classes.logoContainer}>
                <MobileBurgerButton />
                {drawerWidth ? <LogoPng width={120} height={42} /> : ""} 
              </Box>
              {listMenu
                .filter((link) => activeNavLinkList.some((item) => link.id === item.id))
                .map(({ Icon, ...el }) => {
                  const acceptPermission = el.permissionKey.some(
                    (element) => element === userData.role,
                  );
                  const isActive = el.pathnames.includes(params?.pathname);

                  return acceptPermission ? (
                    !el.subList.length ? (
                      <Button
                        fullWidth
                        color="primary"
                        variant={"contained"}
                        onClick={el.link}
                        disableElevation
                        className={`${classes.menuLink} ${isActive && classes.activeMenuLink}`}
                        key={el.id}
                      >
                        <Icon style={{ color: "currentColor" }} />
                        {isMenuOpen && (
                          <Typography variant="body2" style={{ marginLeft: 16 }}>
                            {el.name}
                          </Typography>
                        )}
                      </Button>
                    ) : (
                      <CollapseSubMenu
                        Icon={Icon}
                        data={el}
                        mainClasses={classes}
                        isOptionActive={isActive}
                        isMenuOpen={isMenuOpen}
                        key={el.id}
                      />
                    )
                  ) : null;
                })}
            </Box>
            <Box className={classes.buttonDrawerWidth}>
              <IconButton className={classes.expandCollapseMenu} onClick={handleChangeDrawerWidth}>
                {isMenuOpen ? <KeyboardArrowLeftIcon /> : <KeyboardArrowRightIcon />}
              </IconButton>
            </Box>
          </Box>
        </Drawer>
        <Box className={classes.content}>{children}</Box>
      </Box>
    </>
  );
};
